import { api_get, stringfy_post, api_post } from '../utils/http'
import { IResponse } from '../apps/search/interface/'

const PREFIX = '/csearch/api'

// 获取品类
async function getContentType() {
  const { success, data, msg }: IResponse = await api_get(
    `${PREFIX}/search-tests/get-content-type`,
    {}
  )
  let list: any[] = success ? data.records : []
  return list
}

// 获取已有的循环暗文补充设置
async function getCycleConfig(options) {
  const { success, data } = await api_get(`${PREFIX}/dark-texts/cycle-config`, options)
  return { success, data }
}

// 获取默认的搜索列表
interface IDefaultQueryOptions {
  page: number
  page_size: number
}
async function queryDefaultSearchList(options: IDefaultQueryOptions) {
  const { success, data, msg }: IResponse = await api_get(
    `${PREFIX}/search-tests/default-query`,
    options
  )
  let list: any[] = []
  let total: number = 0

  if (success) {
    list = data.records
    total = data.total
  }

  return { list, total }
}

// 获取搜索列表
interface IQueryOptions {
  content: string
  type: string
  page: number
  page_size: number
}
async function querySearchList(options: IQueryOptions) {
  const { success, data, msg }: IResponse = await stringfy_post(
    `${PREFIX}/search-tests/query`,
    options
  )
  let list: any[] = []
  let total: number = 0
  let word: any = null
  let idiom: any = null

  if (success) {
    list = data.records
    total = data.total
    word = data.word
    idiom = data.idiom
  }

  return { list, total, word, idiom }
}

// 获取提示词
interface ISuggestWords {
  content: string
  type: string
}
async function getSuggestWords(options: ISuggestWords) {
  const { success, msg, data } = await stringfy_post(
    `${PREFIX}/search-tests/get-suggest-words`,
    options
  )

  return success ? [...new Set(data.records)] : []
}

// 获取暗文列表
interface IListOptions {
  page: number
  page_size: number
}
async function getList(options: IListOptions) {
  const { success, data, msg }: IResponse = await api_get(`${PREFIX}/dark-texts/list`, options)
  let list: any[] = []
  let total: number = 0

  if (success) {
    list = data.records.map((item: any, index: number) => {
      return {
        key: index,
        ...item
      }
    })
    total = data.total
  }

  return { list, total }
}

// 创建暗文
interface IAddOptions {
  content: string
}
async function createDarkText(options: IAddOptions) {
  const { success, msg }: IResponse = await stringfy_post(`${PREFIX}/dark-texts/add`, options)

  return { success, msg }
}

// 发布暗文
interface IPublishOptions {
  text_id: string
}
async function publishDarkText(options: IPublishOptions) {
  const { success, msg }: IResponse = await stringfy_post(`${PREFIX}/dark-texts/publish`, options)

  return { success, msg }
}

// 删除暗文
interface IDeleteOptions {
  text_id: string
}
async function deleteDarkText(options: IDeleteOptions) {
  const { success, msg }: IResponse = await stringfy_post(`${PREFIX}/dark-texts/delete`, options)

  return { success, msg }
}

// 获取热门搜索列表
interface IHotList extends IListOptions {}
async function getHotList(options: IHotList) {
  const { success, msg, data }: IResponse = await api_get(`${PREFIX}/hot-searchs/list`, options)
  let list: any[] = []
  let total: number = 0

  if (success) {
    list = data.records.map((item: any, index: number) => {
      return {
        key: index,
        operation: item.status,
        ...item
      }
    })
    total = data.total
  }

  return { list, total }
}

// 创建热搜
interface IHotAddOptions extends IAddOptions {}
async function createHotItem(options: IHotAddOptions) {
  const { success, msg }: IResponse = await stringfy_post(`${PREFIX}/hot-searchs/add`, options)

  return { success, msg }
}

// 修改热搜
interface IEditAddOptions extends IAddOptions {}
async function editHotItem(options: IEditAddOptions) {
  const { success, msg }: IResponse = await stringfy_post(`${PREFIX}/hot-searchs/edit`, options)

  return { success, msg }
}

// 改变热搜发布状态
interface IPublishAction {
  content_id: string
  action: number
}
async function changePublishStatus(options: IPublishAction) {
  const { success, msg }: IResponse = await stringfy_post(
    `${PREFIX}/hot-searchs/pub-action`,
    options
  )

  return { success, msg }
}

// 删除热搜
interface IDeleteItem {
  content_id: string
}
async function deleteHotItem(options: IDeleteItem) {
  const { success, msg }: IResponse = await stringfy_post(`${PREFIX}/hot-searchs/delete`, options)

  return { success, msg }
}

// 改变热搜项目排序
interface IMoveOptions {
  content_id: string
  action: string
}
async function changeItemPosition(options: IMoveOptions) {
  const { success, msg }: IResponse = await stringfy_post(
    `${PREFIX}/hot-searchs/move-action`,
    options
  )

  return { success, msg }
}

// 热搜-目标用户数组
async function getTargetUserList() {
  const res = await api_post(`${PREFIX}/hot-searchs/get_target_user`)

  return res
}

// 改变循环暗文优先级
async function changeDarkTextPosition(options: any) {
  const { success, msg } = await stringfy_post(`${PREFIX}/dark-texts/move-action`, options)

  return { success, msg }
}

// 获取循环暗文一级品类列表
async function getLoopTypeOneList(options) {
  const { success, msg, data } = await api_get(`${PREFIX}/dark-texts/type-one-list`, options)

  return { success, msg, data }
}

// 循环暗文补充设置
async function cycleConfig(options) {
  const { success, msg } = await stringfy_post(`${PREFIX}/dark-texts/cycle-config`, options)

  return { success, msg }
}

/* 黑名单start */
// 获取一级品类列表
async function getTypeOneList(options: {}) {
  const { success, msg, data }: IResponse = await api_get(
    `${PREFIX}/blacklist/type_one_list`,
    options
  )

  return { success, msg, data }
}
// 搜索列表
interface GetBlackList {
  resourceId: string
  resourceName: string
  typeOne: string
  page: number
  pageSize: number
}
async function getBlackList(options: GetBlackList) {
  const { success, msg, data }: IResponse = await stringfy_post(
    `${PREFIX}/blacklist/display`,
    options
  )

  return { success, msg, data }
}

// 添加资源到黑名单
interface AddBlackList {
  resourceId: string
  typeOne: string
}
async function addBlackList(options: AddBlackList) {
  const { success, msg }: IResponse = await stringfy_post(`${PREFIX}/blacklist/add`, options)

  return { success, msg }
}

// 删除资源
interface DeleteResource {
  textId: string
}
async function deleteResource(options: DeleteResource) {
  const { success, msg }: IResponse = await stringfy_post(`${PREFIX}/blacklist/delete`, options)

  return { success, msg }
}

// 操作记录
async function operatedList(options: DeleteResource) {
  const { success, msg, data }: IResponse = await stringfy_post(
    `${PREFIX}/blacklist/operated_list`,
    options
  )

  return { success, msg, data }
}
/* 黑名单end */

// 英语单词
async function queryWords(options: any) {
  const res = await api_post(`${PREFIX}/search-tests/query-words`, options)

  return res
}

// 获取成语列表
async function queryIdiom(options: any) {
  const res = await api_post(`${PREFIX}/search-tests/query-idioms`, options)
  return res
}

// 获取年级
async function getGrades(options: any) {
  const res = await api_post(`${PREFIX}/search-tests/get-grades`, options)

  return res
}

// 查询补充词列表
interface IAdditionalWordsOptions {
  word: string
  first_content_type: string
  status: string
  page: number
}
async function getAdditionalWords(options: IAdditionalWordsOptions) {
  let list = []
  const res = await api_post(`${PREFIX}/additional_words/query`, options)
  const { success, data, total } = res

  if (success) {
    list = data.map((item, index) => {
      return {
        key: index + 1,
        ...item
      }
    })
  }

  return {
    list,
    total
  }
}

// 设置关键词
interface ISetKeywordsOptions {
  id?: string
  word: string
  first_content_type: string
}
async function setKeywords(options: ISetKeywordsOptions) {
  const res = await stringfy_post(`${PREFIX}/additional_words/edit-additional-word`, options)
  return res
}

// 上下线
interface IChangeStatusOptions {
  ids: string[]
  status: string
}
async function changeStatus(options: IChangeStatusOptions) {
  const res = await stringfy_post(`${PREFIX}/additional_words/change-status`, options)
  return res
}

// 删除补充词
interface IDeleteKeywordsOptions {
  ids: string[]
}
async function deleteKeywords(options: IDeleteKeywordsOptions) {
  const res = await stringfy_post(`${PREFIX}/additional_words/delete`, options)
  return res
}

// 查询资源关键字
interface IRecourceWordsOptions {
  word: string
  first_content_type: string
  resource_name: string
  status: string
  page: number
}
async function getRecourceWords(options: IRecourceWordsOptions) {
  let list = []
  const res = await api_post(`${PREFIX}/resource_additional_words/query`, options)
  const { success, data, total } = res

  if (success) {
    list = data.map((item, index) => {
      return {
        key: index + 1,
        ...item
      }
    })
  }

  return {
    list,
    total
  }
}

// 资源-编辑补充词
interface ISetRecourceKeywordsOptions {
  id?: string
  word: string
  resource_id: string
  first_content_type: string
}
async function setRecourceKeywords(options: ISetRecourceKeywordsOptions) {
  const res = await stringfy_post(`${PREFIX}/resource_additional_words/edit`, options)
  return res
}

// 资源-发布、取消发布专有词
interface IChangeRecourceStatusOptions {
  ids: string[]
  status: string
}
async function changeRecourceStatus(options: IChangeRecourceStatusOptions) {
  const res = await stringfy_post(`${PREFIX}/resource_additional_words/change-status`, options)
  return res
}

// 资源-删除补充词
interface IDeleteRecourceKeywordsOptions {
  ids: string[]
}
async function deleteRecourceKeywords(options: IDeleteRecourceKeywordsOptions) {
  const res = await stringfy_post(`${PREFIX}/resource_additional_words/delete`, options)
  return res
}

// 运营关键词--获取列表
interface RunSettingOptions {
  key_word: string
  status: number
  page: number
  page_size: number
}
async function getRunSettingList(options: RunSettingOptions) {
  let list = []
  const res = await api_post(`${PREFIX}/activity_options/get-all`, options)
  const { success, data, total } = res

  if (success) {
    list = data.map((item, index) => {
      return {
        key: index + 1,
        ...item
      }
    })
  }

  return {
    list,
    total
  }
}

// 添加运营关键词
interface AddRSKeywords {
  key_words: string[]
  url: string
}
async function addKeywords(options: AddRSKeywords) {
  const { success, msg }: IResponse = await stringfy_post(`${PREFIX}/activity_options/add`, options)

  return { success, msg }
}

// 关键词-发布、取消发布
interface KeywordsStatusOptions {
  id: string
  status: number
}
async function changeKeywordsStatus(options: KeywordsStatusOptions) {
  const res = await stringfy_post(`${PREFIX}/activity_options/about-release `, options)
  return res
}

// 关键词-删除
interface DeleteRSKeywordsOptions {
  id: string
}
async function deleteRSKeywords(options: DeleteRSKeywordsOptions) {
  const res = await stringfy_post(`${PREFIX}/activity_options/delete`, options)
  return res
}

// 关键词-编辑
interface EditKeywordsOptions {
  id: string
  key_word: string
  url: string
}
async function editKeywordsStatus(options: EditKeywordsOptions) {
  const { success, msg }: IResponse = await stringfy_post(
    `${PREFIX}/activity_options/edit`,
    options
  )
  return { success, msg }
}

// 关键词-状态
async function getPushStatus() {
  const res = await stringfy_post(`${PREFIX}/activity_options/get_push_status`)
  return res
}

export {
  getContentType,
  queryDefaultSearchList,
  querySearchList,
  getSuggestWords,
  getList,
  createDarkText,
  publishDarkText,
  deleteDarkText,
  getHotList,
  createHotItem,
  editHotItem,
  changePublishStatus,
  deleteHotItem,
  changeItemPosition,
  changeDarkTextPosition,
  getLoopTypeOneList,
  cycleConfig,
  getTypeOneList,
  getBlackList,
  addBlackList,
  deleteResource,
  operatedList,
  queryWords,
  queryIdiom,
  getGrades,
  // 关键词补充
  getAdditionalWords,
  setKeywords,
  changeStatus,
  deleteKeywords,
  //资源关键词补充
  getRecourceWords,
  setRecourceKeywords,
  changeRecourceStatus,
  deleteRecourceKeywords,
  getCycleConfig,
  //运营活动关键字
  getRunSettingList,
  addKeywords,
  changeKeywordsStatus,
  deleteRSKeywords,
  editKeywordsStatus,
  getPushStatus,
  getTargetUserList
}
